import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withKeys as _withKeys, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "b-profile-change-password-page" }
const _hoisted_2 = { class: "b-profile-change-password-page__head" }
const _hoisted_3 = { class: "b-profile-change-password-page__title h-pl-10" }
const _hoisted_4 = { class: "h-ph-20" }
const _hoisted_5 = { class: "h-flex-0-0-50p h-ph-10 h-pv-5" }
const _hoisted_6 = { class: "h-flex-0-0-50p h-ph-10 h-pv-5" }
const _hoisted_7 = { class: "h-flex-0-0-50p h-ph-10 h-pv-5" }
const _hoisted_8 = { class: "h-flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FwInput = _resolveComponent("FwInput")!
  const _component_FwFormInput = _resolveComponent("FwFormInput")!
  const _component_FwButton = _resolveComponent("FwButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('LABEL.PASSWORD')), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("form", {
        class: "b-profile-change-password-page__form h-flex h-mt-30 h-mh--20",
        onKeyup: _cache[9] || (_cache[9] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["enter"]))
      }, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_FwFormInput, {
            class: "h-mb-15",
            fieldHasError: _ctx.validation.fieldHasErrorByRule(_ctx.old_password, `old_password`, _ctx.validation.passwordRequirements),
            labelType: "label-thin",
            title: _ctx.$t(`RESET.PASSWORD.CURRENT`)
          }, {
            default: _withCtx(() => [
              _createVNode(_component_FwInput, {
                value: _ctx.old_password,
                type: "password",
                name: "password",
                autocomplete: "current-password",
                placeholder: _ctx.$t(`RESET.PASSWORD.EYE`),
                inputStyle: "gray",
                error: _ctx.validation.getFieldErrorTextByRule(_ctx.old_password, `old_password`, _ctx.validation.passwordRequirements),
                onUpdate: _cache[0] || (_cache[0] = value => _ctx.old_password = value),
                onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.validation.clearServerErrorsBase(`old_password`))),
                onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.validation.addCurrentInputToValidateArray(`old_password`)))
              }, null, 8, ["value", "placeholder", "error"])
            ]),
            _: 1
          }, 8, ["fieldHasError", "title"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_FwFormInput, {
            class: "h-mb-15",
            fieldHasError: _ctx.validation.fieldHasErrorByRule(_ctx.new_password, `new_password`, _ctx.validation.passwordRequirements),
            labelType: "label-thin",
            title: _ctx.$t(`RESET.PASSWORD.NEW`)
          }, {
            default: _withCtx(() => [
              _createVNode(_component_FwInput, {
                value: _ctx.new_password,
                type: "password",
                name: "password",
                autocomplete: "current-password",
                placeholder: _ctx.$t(`RESET.PASSWORD.CHARACTERS`),
                inputStyle: "gray",
                error: _ctx.validation.getFieldErrorTextByRule(_ctx.new_password, `new_password`, _ctx.validation.passwordRequirements),
                onUpdate: _cache[3] || (_cache[3] = value => { _ctx.new_password = value; _ctx.validation.addCurrentInputToValidateArray(`user_confirm_password`); }),
                onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.validation.clearServerErrorsBase(`new_password`))),
                onBlur: _cache[5] || (_cache[5] = ($event: any) => (_ctx.validation.addCurrentInputToValidateArray(`new_password`)))
              }, null, 8, ["value", "placeholder", "error"])
            ]),
            _: 1
          }, 8, ["fieldHasError", "title"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_FwFormInput, {
            class: "h-mb-15",
            fieldHasError: !!_ctx.confirmPasswordError,
            labelType: "label-thin",
            title: _ctx.$t(`RESET.PASSWORD.NEW.CONFIRM`)
          }, {
            default: _withCtx(() => [
              _createVNode(_component_FwInput, {
                value: _ctx.user_confirm_password,
                type: "password",
                name: "password",
                autocomplete: "current-password",
                placeholder: _ctx.$t(`RESET.PASSWORD.CHARACTERS`),
                inputStyle: "gray",
                error: _ctx.confirmPasswordError,
                onUpdate: _cache[6] || (_cache[6] = value => _ctx.user_confirm_password = value),
                onInput: _cache[7] || (_cache[7] = ($event: any) => (_ctx.validation.clearServerErrorsBase(`user_confirm_password`))),
                onBlur: _cache[8] || (_cache[8] = ($event: any) => (_ctx.validation.addCurrentInputToValidateArray(`user_confirm_password`)))
              }, null, 8, ["value", "placeholder", "error"])
            ]),
            _: 1
          }, 8, ["fieldHasError", "title"])
        ])
      ], 32)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_FwButton, {
        class: "h-mt-20 h-ml-10",
        disabled: !_ctx.isFormValid || !_ctx.passwordMatch,
        borderRadiusType: "tiny-border",
        onClick: _ctx.onSubmit
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('BUTTON.CHANGE')), 1)
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ])
  ]))
}